import {AccountState, AccountTypeLabel} from "../../../lib/constants";

const account_states = user => {
  return Object.keys(user.account_state).map((prop, index) => {
    return {
      prop,
      index,
      index_prop: prop,
      state: user.account_state[prop],
    }
  })
}


const CreateAccountMenuData = (user, tda) => {
  const result = [];

  account_states(user).forEach(({index_prop, state}) => {
    if (state === AccountState.LIVE
      || state === AccountState.TEST_PORTFOLIO
      || state === AccountState.RIA_PORTFOLIO
      || state === AccountState.BROKERAGE_PORTFOLIO
      || state === AccountState.TDA_PORTFOLIO) {
      result.push({
        account: tda[index_prop].tda_account_number,
        type: AccountTypeLabel(tda[index_prop].account_type),
      })
    } else if (state === AccountState.ONBOARDING) {
      result.push({
        account: tda[index_prop]
          ? tda[index_prop].tda_account_number
          : "PENDING",
        type: "Onboarding",
      })
    } else if (state === AccountState.SIGNED || state === AccountState.SIGNED_PROXY) {
      result.push({
        account: tda[index_prop].tda_account_number,
        type: "Signed",
      })
    } else if (state === AccountState.CLOSED) {
      result.push({
        account: tda[index_prop].tda_account_number,
        type: "Closed",
      })
    } else  {
      result.push({
        account: tda[index_prop].tda_account_number,
        type: "UNKNOWN",
      })
    }
  });
  return result;
};

export { CreateAccountMenuData };
